import React from "react";
import { HeadphonesIcon, ShieldCheckIcon, ZapIcon } from "lucide-react";
import { trustItems } from "../data/content";
const icons = [ShieldCheckIcon, HeadphonesIcon, ZapIcon];
export function TrustBadges() {
  return <section className="bg-white px-4 pb-14" aria-labelledby="trust-title" data-id="element-174" data-mp="32j2b855v0gqe">
      <div className="mx-auto max-w-5xl" data-id="element-175" data-mp="2xiep9xwhmq31">
        <h2 id="trust-title" className="text-center font-heading text-2xl font-bold" data-id="element-176" data-mp="2xhd2iw640f5h">
          Safe purchase, ongoing support, instant delivery.
        </h2>
        <div className="mt-8 grid gap-5 md:grid-cols-3" data-id="element-177" data-mp="37hm1uiveegp3">
          {trustItems.map((t, i) => {
          const Icon = icons[i];
          return <div key={t.title} className="rounded-lg bg-peach p-6" data-id="element-178" data-mp="3l7z9sl8ahvef" data-mpi={i}>
                <Icon className="h-6 w-6 text-brand" aria-hidden="true" data-id="element-179" data-mp="3h6nfw3iduo0f" />
                <h3 className="mt-3 font-heading font-semibold" data-id="element-180" data-mp="3v6f0wo7bh4nx">{t.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink-muted" data-id="element-181" data-mp="3v4c0da8jft4y">{t.text}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}